module.exports = __webpack_public_path__ + "static/media/TikTok__2.b3558762.mp4";